import { appstr } from "./appstr";
import { QAlert } from "../CoreApp/QAlert";
import { Globals } from "../CoreApp/Globals";
import { CheckFileValid } from "./CheckFileValid";

export function DoUploadFile() {
  var success = true;
  var f = document.getElementById("uploadform");
  var i = document.getElementById("selectfile");
  var files = i.files;
  if (files == null) return false;

  if (Globals._wsMgr.fFileMgr == null && files && files.length > 1) {
    var w = new QAlert();
    w.InitAlert(appstr("Alert"), appstr("uploadfailmultiplefiles"), null, Globals._wsMgr);
    return;
  }

  var fileNames = [];
  for (var j = 0; j < files.length; j++) {
    var fileObj = files[j];
    success = CheckFileValid(fileObj);
    if (success === false) return false;
    fileNames.push(fileObj.name);
  }

  var uploadMgr = i["uploadmgr"];
  var org = i["curorg"];
  var dir = i["curdir"];
  var user = i["curuser"];

  var data = {};
  data["files"] = fileNames;
  var jsonData = JSON.stringify(data);

  i["filenames"] = fileNames;

  uploadMgr.CheckFileExists(org, user, dir, jsonData);
  return success;
}
